<template lang="pug">
  div
    md-card.md-card-profile(v-if="!isPaid")
      md-card-header(data-background-color='green')
        h4.title USIT Membership
        p.category Become a Paid Member Now
      md-card-content
        span Become a paid USIT member to access General Meetings year round and USIT Portal's full functionality, including USIT Trading and Resources.<br>
        md-button.md-round.md-success(v-on:click='goPro') Let's do it
    md-card.md-card-profile(v-else)
      md-card-header(data-background-color='green')
        h4.title USIT Membership
        p.category You're all set!
      md-card-content
        span Thank you for being a paid USIT member! <br> Enjoy the full functionality of USIT Portal and other Paid Membership perks.<br> 
        md-button.md-round.md-success(v-on:click='goPro') View other memberships
</template>

<script>
export default {
  props: {
    isPaid: Boolean
  },
  data() {
    return {};
  },
  methods: {
    goPro() {
      this.$router.push({name: 'Payment'});
    }
  }
};
</script>
<style></style>



// WEBPACK FOOTER //
// src/pages/UserManagement/GoPro.vue